/**
 * 价格数据API
 */
import { apiClient } from './client';
import type { PriceData, PriceStatistics } from '../types';

export interface PriceQueryParams {
  start_date?: string;
  end_date?: string;
  data_source?: string;
  currency?: 'CNY' | 'USD';
}

export interface StatisticsQueryParams {
  start_date?: string;
  end_date?: string;
  granularity?: 'day' | 'week' | 'month' | 'quarter' | 'year';
}

// 获取V2O5价格数据
export const getV2O5Prices = async (params?: PriceQueryParams): Promise<PriceData[]> => {
  return apiClient.get('/prices/v2o5', { params });
};

// 获取钒铁价格数据
export const getFevPrices = async (params?: PriceQueryParams): Promise<PriceData[]> => {
  return apiClient.get('/prices/fev', { params });
};

// 获取价格统计数据
export const getPriceStatistics = async (
  metal_type: string,
  params?: StatisticsQueryParams
): Promise<PriceStatistics> => {
  return apiClient.get('/prices/statistics', {
    params: { metal_type, ...params },
  });
};
